import React, { useContext } from "react";
import { FormBuilderContext, ACTIONS } from "../context/context";

import InputSection from "../components/InputSection";
import ColorPickerInput from "../components/ColorPickerInput";
import CustomSelect from "../components/CustomSelect";
import FontFamilySelect from "../components/FontFamilySelect";
import { FormBuilderSwitch } from "../components/Switch";

const FieldLabelGroup = () => {
    const { state, dispatch } = useContext(FormBuilderContext);

    const handleColorChange = (actionType) => (color) => {
        dispatch({ type: actionType, payload: color });
    };

    const handleFontWeightChange = (event) => {
        dispatch({
            type: ACTIONS.FIELD_LABEL_FONT_WEIGHT_INPUT,
            payload: event.target.value,
        });
    };

    const handleFieldLabelFontFamilyChange = (event) => {
        dispatch({
            type: ACTIONS.FIELD_LABEL_FONT_FAMILY_CHANGE,
            payload: event.target.value,
        });
    };

    const handleFieldLabelAlignmentChange = (event) => {
        dispatch({
            type: ACTIONS.FIELD_LABEL_ALIGNMENT,
            payload: event.target.value,
        });
    };

    const handleToggleDescription = (event) => {
        dispatch({
            type: ACTIONS.TOGGLE_DESCRIPTION,
            payload: event.target.checked,
        });
    };
    
    const handleDescriptionFontWeightChange = (event) => {
        dispatch({
            type: ACTIONS.DESCRIPTION_FONT_WEIGHT_INPUT,
            payload: event.target.value,
        });
    };

    const handleDescriptionFontFamilyChange = (event) => {
        dispatch({
            type: ACTIONS.DESCRIPTION_FONT_FAMILY_CHANGE,
            payload: event.target.value,
        });
    };

    const handleToggleRemoveLabels = (event) => {
        dispatch({
          type: ACTIONS.TOGGLE_FIELD_LABEL,
          payload: event.target.checked,
        });
      };
    

    return (
        <>

            <div>
                <p>Remove Labels?</p>
                <FormBuilderSwitch
                    checked={state.removeFieldLabels}
                    onChange={handleToggleRemoveLabels}
                />
            </div>
            
            {!state.removeFieldLabels && (
                <div>
            {/* #####################################  FONT STYLES  ########################################### */}

            <h2 className="section-subheader">Font styles</h2>
            <div className="input-group-wrapper">

                <div className="form-builder-section-div">
                    <p>Font Family</p>
                    <FontFamilySelect
                        selectedFontFamily={state.fieldLabelFontFamily}
                        onFontFamilyChange={handleFieldLabelFontFamilyChange}
                    />
                </div>

                <InputSection
                    id="fieldLabelFontSize"
                    title="Font size"
                    value={state.fieldLabelFontSize}
                    actionTypeIncrement={ACTIONS.FIELD_LABEL_FONT_SIZE_INCREMENT}
                    actionTypeDecrement={ACTIONS.FIELD_LABEL_FONT_SIZE_DECREMENT}
                    actionTypeInput={ACTIONS.FIELD_LABEL_FONT_SIZE_INPUT}
                    dispatch={dispatch}
                />
                <div>
                    <p>Font Weight</p>
                    <CustomSelect
                        labelId="font-weight-select-label"
                        id="font-weight-select"
                        selectValue={state.fieldLabelFontWeight}
                        selectLabel="Font Weight"
                        selectOnChange={handleFontWeightChange}
                        menuItems={[
                            { value: 100, label: "100" },
                            { value: 200, label: "200" },
                            { value: 300, label: "300" },
                            { value: 400, label: "400" },
                            { value: 500, label: "500" },
                            { value: 600, label: "600" },
                            { value: 700, label: "700" },
                            { value: 800, label: "800" },
                            { value: 900, label: "900" },
                        ]}
                    />
                </div>
            </div>

            {/* #####################################  SPACING  ########################################### */}

            <h2 className="section-subheader">Spacing</h2>
            <div className="input-group-wrapper">

                <InputSection
                    id="fieldLabelBottomSpacing"
                    title="Bottom Spacing"
                    value={state.fieldLabelBottomSpacing}
                    actionTypeIncrement={ACTIONS.FIELD_LABEL_BOTTOM_SPACING_INCREMENT}
                    actionTypeDecrement={ACTIONS.FIELD_LABEL_BOTTOM_SPACING_DECREMENT}
                    actionTypeInput={ACTIONS.FIELD_LABEL_BOTTOM_SPACING_INPUT}
                    dispatch={dispatch}
                />

                <InputSection
                    id="fieldLabelPadding"
                    title="Padding"
                    value={state.fieldLabelPadding}
                    actionTypeIncrement={ACTIONS.FIELD_LABEL_PADDING_INCREMENT}
                    actionTypeDecrement={ACTIONS.FIELD_LABEL_PADDING_DECREMENT}
                    actionTypeInput={ACTIONS.FIELD_LABEL_PADDING_INPUT}
                    dispatch={dispatch}
                />

            </div>

            {/* #####################################  COLOR STYLES  ########################################### */}

            <h2 className="section-subheader">Color styles </h2>
            <div className="input-group-wrapper">
                <div className="form-builder-section-div">
                    <p>Text Color</p>
                    <ColorPickerInput
                        color={state.fieldLabelColor}
                        onChange={handleColorChange(ACTIONS.FIELD_LABEL_COLOR_INPUT)}
                    />
                </div>

                <div className="form-builder-section-div">
                    <p>Asterisk Color</p>
                    <ColorPickerInput
                        color={state.fieldLabelColorAsterisk}
                        onChange={handleColorChange(ACTIONS.FIELD_LABEL_COLOR_ASTERISK)}
                    />
                </div>
            </div>

            {/* #####################################  ALIGNMENT  ########################################### */}

            <h2 className="section-subheader">Alignment</h2>

            <div className="input-group-wrapper">
                <div className="form-builder-section-div">
                    <p>Choose layout</p>
                    <CustomSelect
                        labelId="field-label-alignment"
                        id="field-label-alignment"
                        selectValue={state.fieldLabelAlignment}
                        selectLabel="Chekcbox Alignment"
                        selectOnChange={handleFieldLabelAlignmentChange}
                        menuItems={[
                            { value: "row", label: "horizontal" },
                            { value: "column", label: "stacked" },
                        ]}
                    />
                </div>
            </div>
</div>
            )}
            {/* #####################################  DESCRIPTION  ########################################### */}


            <p>Did you use descriptions for your fields?</p>
            <FormBuilderSwitch
                checked={state.addDescription}
                onChange={handleToggleDescription}
            />
            {state.addDescription && (
                <>
                    <h2 className="section-subheader">Font styles</h2>
                    <div className="input-group-wrapper">
                        <div className="form-builder-section-div">
                            <p>Font Family</p>
                            <FontFamilySelect
                                selectedFontFamily={state.FontFamily}
                                onFontFamilyChange={handleDescriptionFontFamilyChange}
                            />
                        </div>

                        <InputSection
                            id="descriptionFontSize"
                            title="Font size"
                            value={state.descriptionFontSize}
                            actionTypeIncrement={ACTIONS.DESCRIPTION_FONT_SIZE_INCREMENT}
                            actionTypeDecrement={ACTIONS.DESCRIPTION_FONT_SIZE_DECREMENT}
                            actionTypeInput={ACTIONS.IDESCRIPTION_FONT_SIZE_INPUT}
                            dispatch={dispatch}
                        />
                        <div>
                            <p>Font Weight</p>
                            <CustomSelect
                                labelId="font-weight-description"
                                id="font-weight-description"
                                selectValue={state.descriptionFontWeight}
                                selectLabel="Font Weight"
                                selectOnChange={handleDescriptionFontWeightChange}
                                menuItems={[
                                    { value: 100, label: "100" },
                                    { value: 200, label: "200" },
                                    { value: 300, label: "300" },
                                    { value: 400, label: "400" },
                                    { value: 500, label: "500" },
                                    { value: 600, label: "600" },
                                    { value: 700, label: "700" },
                                    { value: 800, label: "800" },
                                    { value: 900, label: "900" },
                                ]}
                            />
                        </div>
                    </div>

                    <h2 className="section-subheader">Spacing</h2>
                    <div className="input-group-wrapper">
                        <InputSection
                            id="descriptionTopSpacing"
                            title="Spacing above"
                            value={state.descriptionTopSpacing}
                            actionTypeIncrement={ACTIONS.DESCRIPTION_TOP_SPACING_INCREMENT}
                            actionTypeDecrement={ACTIONS.DESCRIPTION_TOP_SPACING_DECREMENT}
                            actionTypeInput={ACTIONS.DESCRIPTION_TOP_SPACING_INPUT}
                            dispatch={dispatch}
                        />

                        <InputSection
                            id="descriptionPaddingInline"
                            title="Inline padding"
                            value={state.descriptionPaddingInline}
                            actionTypeIncrement={ACTIONS.DESCRIPTION_INLINE_PADDING_INCREMENT}
                            actionTypeDecrement={ACTIONS.DESCRIPTION_INLINE_PADDING_DECREMENT}
                            actionTypeInput={ACTIONS.DESCRIPTION_INLINE_PADDING_INPUT}
                            dispatch={dispatch}
                        />
                    </div>

                    <h2 className="section-subheader">Color styles </h2>
                    <div className="input-group-wrapper">
                        <div className="form-builder-section-div">
                            <p>Text Color</p>
                            <ColorPickerInput
                                color={state.inputColor}
                                onChange={handleColorChange(ACTIONS.DESCRIPTION_COLOR_INPUT)}
                            />
                        </div>

                    </div>
                </>
            )}


            {/* ################################################################################ */}
        </>
    );
};

export default FieldLabelGroup;
